import { render } from "./PageTitle.vue?vue&type=template&id=0dede48c&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=0dede48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dede48c"]])

export default __exports__